<nav class="navbar navbar-expand-lg navbar-dark bg-primary d-print-none encima">
    <div class="container-fluid">
        <a class="navbar-brand clickable">Gestión A</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                <li *ngIf="nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarMantenimientos" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Mantenimientos</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuMantenimientos; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersMantenimientos.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarCompras && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarCompras" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Compras</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuCompras; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersCompras.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarCamping && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarCamping" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Camping</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuCamping; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersCamping.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarTienda && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarTienda" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Tienda</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuTienda; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersTienda.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarBar && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarBar" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Bar</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuBar; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersBar.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarTaller && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarBar" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Taller</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuTaller; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersTaller.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarFabricacion && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarBar" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Fabricación</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuFabricacion; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersFabricacion.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarPeluqueria && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarBar" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Peluquería</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuPeluqueria; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersPeluqueria.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarAlmacen && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarAlmacen" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Almacén</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuAlmacen; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersAlmacen.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarHostal && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarHostal" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Hostal</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuHostal; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersHostal.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarLogistica && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarLogistica" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Logística</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuLogistica; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersLogistica.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarCaja && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarCaja" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Caja</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuCaja; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersCaja.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarCaja2 && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarCaja" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Caja</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuCaja2; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersCaja2.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarVentas && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarVentas" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Ventas</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuVentas; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersVentas.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarInformes" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Informes</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuInformes; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersInformes.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarAgro && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarInformes" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Agro</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuAgro; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersAgro.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarContabilidad && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarInformes" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Contabilidad</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuContabilidad; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersContabilidad.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarVerifactu && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarInformes" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Verifactu</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuVerifactu; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersVerifactu.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="mostrarTiendaWeb && nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarInformes" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Tienda Web</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuTiendaWeb; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersTiendaWeb.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="nivel > 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Utilidades</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuUtilidades; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersUtilidades.includes(i);" class="dropdown-divider">
                        </li>
                    </ul>
                </li>

                <li *ngIf="nivel == 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">TPV</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li *ngFor="let item of menuTPV; let i = index;">
                            <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a>
                            <hr *ngIf="dividersTPV.includes(i);" class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item clickable" (click)="logout()" >Salir</a>
                        </li>
                    </ul>
                </li>

                <!-- <li *ngIf="nivel == 1" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">TPV</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                            <a class="dropdown-item clickable" (click)="logout()" >Salir</a>
                        </li>
                    </ul>
                </li> -->

                <li *ngIf="nivel > 1" (click)="cargarVentanas()" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle clickable" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="true" style="color:white;">Ventanas</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item clickable" (click)="activarFlotante()">Panel Flotante</a>
                        <li *ngFor="let item of ventanas; let i = index;">
                            <!-- <a class="dropdown-item" [routerLink]='item.ruta' (contextmenu)="abrirPestana(item.ruta)">{{item.texto}}</a> -->
                            <a class="dropdown-item clickable" (contextmenu)="borrarVentana(item)" (click)="abrirPestana(item.ruta)">{{item.texto}}</a>
                        </li>
                    </ul>
                </li>

            </ul>
            <!-- <form class="d-flex">
                <input class="form-control me-2" type="search" placeholder="Búsqueda" aria-label="Búsqueda">
                <button class="btn btn-outline-success" type="submit">Búsqueda</button>
            </form> -->
        </div>
        <button *ngIf="nivel > 1 && botonAbrirCajon" (click)="abrirCajon()" type="button" class="btn btn-primary btn-block text-center">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cash-coin" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/>
            <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/>
            <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/>
            <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/>
          </svg>
        </button>
        <button *ngIf="nivel > 1" (click)="anclar()" type="button" class="btn btn-primary btn-block text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
            </svg>
        </button>
    </div>
</nav>